export default function HeaderBilingualLabel({ en, ko }) {
  return (
    <span className="ds-header-bilingual">
      <span className="ds-header-bilingual__layer">{en}</span>
      <span className="ds-header-bilingual__layer ds-header-bilingual__layer--alt">{ko}</span>
    </span>
  );
}
